import styled from 'styled-components';

export const ImportSummaryStyled = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  max-width: 920px;
`;

export const ImportSummaryButtonsContainer = styled.div`
  display: flex;
  margin: 24px 0;
`;

export const ImportSummaryErrorsSectionStyled = styled.aside`
  max-height: 470px;
  overflow-y: auto;
`;
